import React from 'react';
import '../CSS/PrivacyPolicy.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <h1>Privacy Policy</h1>
        <p><strong>Effective Date:</strong> August 2025</p>

        <p>This website ("Site") is operated by Zemantics LLC ("Company"). At Zemantics LLC, we are committed to protecting your privacy online. This Privacy Policy outlines what information we collect, how we use it, and the choices you have regarding your information. By using our Site, you consent to the practices outlined in this policy.</p>

        <h2>1. Updates to This Policy</h2>
        <p>This Privacy Policy may be updated periodically. If changes are material, we will notify you via email or by posting a prominent notice on our Site. Continued use of the Site after any changes constitutes your acceptance of the revised policy.</p>

        <h2>2. Information We Collect</h2>
        <ul>
          <li>Contact Forms: Name, phone number, and email address for communications and newsletters.</li>
          <li>Support or Inquiry: If you contact us, we may use the information to respond and provide follow-up communication.</li>
          <li>Co-branded Offers: We will clearly identify the applicable party and privacy policy in joint efforts.</li>
        </ul>

        <h2>3. Optional and Anonymous Data</h2>
        <p>You may browse our Site anonymously. We may automatically collect non-personally identifiable data such as browser type, domain name, and page visits, used solely for analytics and performance improvement.</p>

        <h2>4. Personal Information Use</h2>
        <p>We may use your personal data to:</p>
        <ul>
          <li>Deliver newsletters and respond to inquiries</li>
          <li>Process service registrations and payments</li>
          <li>Improve Site experience and functionality</li>
          <li>Run marketing campaigns or targeted ads (e.g., social media or email)</li>
        </ul>

        <h2>5. Cookies</h2>
        <p>This Site uses cookies to enhance your experience. Cookies allow us to remember your preferences, analyze traffic, and serve personalized content. You can disable cookies in your browser settings, but doing so may limit some Site functionality.</p>

        <h2>6. Data Sharing with Third Parties</h2>
        <p>We may share your information with trusted service providers (e.g., email marketing platforms, payment processors) strictly for operational purposes. These partners are expected to maintain the confidentiality and security of your data. We do not sell your data to third parties.</p>

        <h2>7. Payment Processing</h2>
        <p>We use third-party payment processors that comply with industry security standards, including GDPR and PCI-DSS. We do not store your credit card information on our servers.</p>

        <h2>8. User Rights and Choices</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Request access to your personal data</li>
          <li>Correct or delete your data ("Right to be Forgotten")</li>
          <li>Withdraw consent at any time</li>
          <li>Request data portability</li>
          <li>Restrict or object to processing</li>
          <li>File a complaint with a supervisory authority</li>
        </ul>
        <p>To exercise these rights, contact us at <a href="mailto:info@zemanticsllc.com">info@zemanticsllc.com</a>.</p>

        <h2>9. Email Communications</h2>
        <p>We may contact you based on consent or legitimate interest. You can unsubscribe at any time using the link provided in our emails.</p>

        <h2>10. Data Retention</h2>
        <p>We retain personal data only as long as necessary to fulfill its original purpose or to comply with legal obligations.</p>

        <h2>11. Security Measures</h2>
        <p>We use commercially reasonable methods to secure your information. While no method is 100% secure, we strive to protect your data from unauthorized access. In the event of a known breach, we will notify affected users promptly.</p>

        <h2>12. Children's Privacy</h2>
        <p>We do not knowingly collect information from individuals under the age of 18. Our website is not intended for children.</p>

        <h2>13. External Links</h2>
        <p>Our Site may contain links to third-party websites. We are not responsible for their privacy practices. Please review their policies individually.</p>

        <h2>14. Access and Updates</h2>
        <p>To review, update, or delete your personal information, please contact us at <a href="mailto:info@zemanticsllc.com">info@zemanticsllc.com</a>.</p>

        <h2>15. Data Controller and Processors</h2>
        <p>Zemantics LLC is the controller of your personal data. We work with trusted processors who comply with GDPR and maintain strict confidentiality.</p>

        <h2>16. Contact</h2>
        <p>If you have any questions or concerns about this Privacy Policy, please contact us at <a href="mailto:info@zemanticsllc.com">info@zemanticsllc.com</a>.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

